export default "__VITE_IMAGE_ASSET__dd49dc2c__";